import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import Alert from 'antd/es/alert/Alert';
import type { ReactNode } from 'react';

import { withSandbox } from 'utils/withSandbox';

type Props = {
  message: ReactNode;
};

const SandboxAlert = withSandbox(({ message }: Props) => (
  <Alert
    className="border-none bg-surface-muted text-content-primary"
    message={message}
    icon={
      <ExclamationCircleIcon className="mb-auto size-5 rotate-180 !text-content-subtle" />
    }
    showIcon
  />
));

export { SandboxAlert };
